/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */


/**
 * Diagnostics Info Service
 * author: Satyaki Bose
 * @file DiagnosticsInfoService.js
 */

import Framework, { BaseService } from '@greenville/framework';
import { DIAGNOSTICS_SERVICE_REQUESTED } from '../../../common/constants';

export default class DiagnosticsInfoService extends BaseService {
  constructor() {
    super(DIAGNOSTICS_SERVICE_REQUESTED, 'DiagnosticInfoStatus');
    this.courseRegistrarId = '';
  }

  /**
   * Trigger the diagnostics info API
   *
   * @returns {Promise}
   */
  handleEvent(eventName, event = {}) {
    const { data = {} } = event;
    this.courseRegistrarId = data.courseRegistrarId || '';
    return this.getClient('marinV2').get(`/launchContext/${data.launchContextId}?data=diagnostic`);
  }

  /**
   * Handle diagnostics info API response`
   *
   * @param {Object} response
   */
  handleResponse(response) {
    Framework.getStoreRegistry()
      .getStore('bookshelf')
      .setDiagnosticsInfo(response.data, this.courseRegistrarId);
  }

  /**
   * Handle errors from the diagnostics info API
   *
   * @param {Object} error
   */
  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    const diagnosticsError = { isError: true };
    Framework.getStoreRegistry()
      .getStore('bookshelf')
      .setDiagnosticsInfo(diagnosticsError, this.courseRegistrarId);
    console.error('Diagnostics Info Service Error:', error);
  }
}
